import { render, staticRenderFns } from "./HomeWellbeing.vue?vue&type=template&id=3c3a5977"
import script from "./HomeWellbeing.vue?vue&type=script&lang=js"
export * from "./HomeWellbeing.vue?vue&type=script&lang=js"
import style0 from "./HomeWellbeing.vue?vue&type=style&index=0&id=3c3a5977&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports